module.exports = __webpack_public_path__ + "img/lathaal_mystic_twister.4cae0bfc.png";